import { CheckCircle2 } from "lucide-react";
import { getStrengthBarColor, type PasswordRequirement } from "@/lib/password-validation";

interface PasswordStrengthIndicatorProps {
  strength: {
    strength: number;
    label: string;
    color: string;
    percentage: number;
  };
  requirements: PasswordRequirement[];
  strengthLabel: string;
}

export function PasswordStrengthIndicator({
  strength,
  requirements,
  strengthLabel,
}: PasswordStrengthIndicatorProps) {
  if (!strength.label) return null;

  return (
    <div className="space-y-2">
      {/* Strength Bar */}
      <div className="flex items-center justify-between text-sm">
        <span className="text-muted-foreground">{strengthLabel}:</span>
        <span className={`font-semibold ${strength.color}`}>
          {strength.label}
        </span>
      </div>
      <div className="h-2 bg-border/50 rounded-full overflow-hidden">
        <div 
          className={`h-full transition-all duration-300 ${getStrengthBarColor(strength.strength)}`}
          style={{ width: `${strength.percentage}%` }}
          role="progressbar"
          aria-valuenow={strength.percentage}
          aria-valuemin={0}
          aria-valuemax={100}
        />
      </div>

      {/* Requirements Checklist */}
      <ul className="text-xs space-y-1 mt-2">
        {requirements.map((requirement, index) => (
          <li 
            key={index}
            className={`flex items-center gap-2 transition-colors ${
              requirement.met ? "text-green-500" : "text-muted-foreground"
            }`}
          >
            <CheckCircle2 className="w-3 h-3" />
            {requirement.label}
          </li>
        ))}
      </ul>
    </div>
  );
}
